import type { DashboardOverview } from '../components/dashboard/DashboardStatsGrid';

export interface PartnerBreakdown {
  partnerDrivers: number;
  partnerDeliveryPartners: number;
  partnerMerchants: number;
  partnerServiceProviders: number;
  totalPartners: number;
}

export function getPartnerBreakdown(overview: DashboardOverview = {}): PartnerBreakdown {
  const partnerDrivers = overview.partnerDrivers ?? 0;
  const partnerDeliveryPartners = overview.partnerDeliveryPartners ?? 0;
  const partnerMerchants = 0;
  const partnerServiceProviders = overview.partnerServiceProviders ?? 0;
  const computedTotal = partnerDrivers + partnerDeliveryPartners + partnerServiceProviders;

  return {
    partnerDrivers,
    partnerDeliveryPartners,
    partnerMerchants,
    partnerServiceProviders,
    totalPartners: overview.totalPartners != null
      ? Math.max(0, (overview.totalPartners ?? 0) - (overview.partnerMerchants ?? 0))
      : computedTotal,
  };
}

/** Summarise active partner accounts by role for dashboard hints. */
export function formatPartnerHint(overview: DashboardOverview = {}): string {
  const {
    partnerDrivers,
    partnerDeliveryPartners,
    partnerServiceProviders,
    totalPartners,
  } = getPartnerBreakdown(overview);

  if (totalPartners <= 0) return 'No active partner accounts';

  const parts = [
    partnerDrivers > 0 ? `${partnerDrivers.toLocaleString()} drivers` : null,
    partnerDeliveryPartners > 0 ? `${partnerDeliveryPartners.toLocaleString()} delivery` : null,
    partnerServiceProviders > 0 ? `${partnerServiceProviders.toLocaleString()} providers` : null,
  ].filter(Boolean);

  return parts.length ? parts.join(' · ') : `${totalPartners.toLocaleString()} active partners`;
}
